import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InviteGuestUserResponseDto } from '../helpers/InterfacesServer';

interface VendorInvitationsReportDictState {
  value: Map<string, InviteGuestUserResponseDto>
}

export const vendorInvitationsReportDict = createSlice({
  name: 'vendorInvitationsReportDict',
  initialState: {
    value: new Map<string, InviteGuestUserResponseDto>(),
  } as VendorInvitationsReportDictState,
  reducers: {
    setVendorInvitationsReportDict: (state, action: PayloadAction<Map<string, InviteGuestUserResponseDto>>) => {
      state.value = action.payload
    },
  },
})

export const { setVendorInvitationsReportDict } = vendorInvitationsReportDict.actions;
export default vendorInvitationsReportDict.reducer;